(function () {
  'use strict';

  /* Ponuka v potvrdení „pridané do košíka".

     Musí byť v JS, nie v Liquide: potvrdenie sa vykresľuje raz pri načítaní
     stránky, ale to, čo v ňom má stáť, závisí od toho, čo je v košíku PRÁVE
     TERAZ. Preto sa pri každom otvorení dotiahne /cart.js a texty sa doplnia.

     Čísla sú počítané tak, aby nesľubovali viac, než pokladňa naozaj dá:
     Shopify nesčítava dve produktové zľavy na tej istej položke, použije tú
     výhodnejšiu. Preto sa počíta len ROZDIEL oproti zľave, ktorú už položka
     má — nie plných 15 % navrch. */

  var STATE = { cart: null, at: 0 };

  function money(cents) {
    var value = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat('sk-SK', {
        style: 'currency', currency: 'EUR', minimumFractionDigits: 2
      }).format(value);
    } catch (error) {
      return value.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function isShirt(item) {
    var type = String(item.product_type || '').toLowerCase();
    var title = String(item.product_title || item.title || '').toLowerCase();
    return /tri[cč]|shirt/.test(type) || /tri[cč]k/.test(title);
  }

  function isArt(item, artHandle) {
    if (item.handle === artHandle) return true;
    var props = item.properties || {};
    var type = props['_Typ doručenia'] || props['_Typ dorucenia'] || '';
    return String(type) === 'custom_art';
  }

  function readCart() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : null; });
  }

  function analyse(cart, pct, artHandle, perArt) {
    var out = { hasArt: false, shirtCount: 0, extraSaving: 0, total: Number(cart.total_price) || 0 };
    var cheapest = 0;
    (cart.items || []).forEach(function (item) {
      if (isArt(item, artHandle)) out.hasArt = true;
      if (!isShirt(item)) return;
      var qty = Number(item.quantity) || 1;
      out.shirtCount += qty;

      /* V257: rátalo sa cez všetky tričká v košíku. Zľava je pritom
         „jeden obraz = jedno tričko", takže pri piatich tričkách sme
         sľubovali päťnásobok. Berieme úsporu na jednom kuse, a to na
         najlacnejšom — sľúbená suma tak nikdy nie je vyššia než skutočná. */
      var unitOriginal = (Number(item.original_line_price) || 0) / qty;
      var unitFinal = (Number(item.final_line_price) || 0) / qty;
      var extra = Math.round(unitOriginal * pct / 100) - Math.round(unitOriginal - unitFinal);
      if (extra > 0 && (cheapest === 0 || extra < cheapest)) cheapest = extra;
    });
    var units = Math.min(Number(perArt) || 1, out.shirtCount);
    out.extraSaving = cheapest * units;
    return out;
  }

  function paint(node, data) {
    var title = node.querySelector('[data-ao-upsell-title]');
    var sub = node.querySelector('[data-ao-upsell-sub]');
    var cta = node.querySelector('[data-ao-upsell-cta]');
    var tag = node.querySelector('[data-ao-upsell-tag]');
    if (title) title.textContent = data.title;
    if (sub) sub.textContent = data.sub;
    if (tag) tag.textContent = data.tag;
    if (cta) {
      cta.textContent = data.cta || '';
      cta.parentNode.hidden = !data.cta;
    }
    if (data.href) node.setAttribute('href', data.href);
    node.classList.toggle('is-done', Boolean(data.done));
    node.hidden = false;
  }

  function refresh(node) {
    var pct = Number(node.getAttribute('data-pct')) || 15;
    var artHandle = node.getAttribute('data-art-handle') || '';
    var artUrl = node.getAttribute('data-art-url') || '';
    var shirtsUrl = node.getAttribute('data-shirts-url') || '';

    return readCart().then(function (cart) {
      if (!cart) return;
      var perArt = Number(node.getAttribute('data-per-art')) || 1;
      var info = analyse(cart, pct, artHandle, perArt);

      /* Tričká v košíku, obraz nie — to je ten najcennejší moment. Ukážeme
         konkrétne, na koľko by objednávka klesla. Percento nikoho nepohne. */
      if (info.shirtCount > 0 && !info.hasArt && info.extraSaving > 0) {
        paint(node, {
          tag: '−' + money(info.extraSaving),
          title: 'Pridaj obraz svojho auta a tričko máš o ' + pct + ' % lacnejšie',
          sub: 'Tričká v košíku by si mal za ' + money(info.total - info.extraSaving)
            + ' namiesto ' + money(info.total) + '.',
          cta: 'Vytvoriť obraz auta',
          href: artUrl
        });
        return;
      }

      // Obraz v košíku, tričko zatiaľ nie — zľava čaká nevyužitá.
      if (info.hasArt && info.shirtCount === 0) {
        paint(node, {
          tag: '−' + pct + ' %',
          title: 'K obrazu máš ktorékoľvek tričko o ' + pct + ' % lacnejšie',
          sub: 'Jeden obraz = jedna zľava. Platí na jedno tričko.',
          cta: 'Vybrať tričko',
          href: shirtsUrl
        });
        return;
      }

      // Obidve veci v košíku — už netlačíme, len potvrdíme.
      if (info.hasArt && info.shirtCount > 0) {
        paint(node, {
          tag: '✓',
          title: 'Zľava ' + pct + ' % na tričko je aktívna',
          sub: 'Jeden obraz = jedna zľava. V košíku ju uvidíš priamo pri tričku.',
          cta: '',
          done: true
        });
        return;
      }

      // Ani jedno (napr. len nálepky) — ponuku neukazujeme vôbec.
      node.hidden = true;
    }).catch(function () { /* ostane východiskový text z Liquidu */ });
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-ao-upsell-live]');
    if (!nodes.length) return;

    /* Potvrdenie sa otvára pridaním triedy is-open na obal. Počúvame priamo
       na tej zmene — spoľahlivejšie než hádať poradie udalostí košíka. */
    nodes.forEach(function (node) {
      var panel = node.closest('[data-ao-added]') || node.parentNode;
      var observer = new MutationObserver(function () {
        if (panel.classList && panel.classList.contains('is-open')) refresh(node);
      });
      observer.observe(panel, { attributes: true, attributeFilter: ['class', 'hidden'] });
      if (panel.classList && panel.classList.contains('is-open')) refresh(node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
